<!-- Global Loader -->
<div id="global-loader" class="global-loader">
  <div class="loader-spinner"></div>
</div>

<div class="parent" *ngIf="showApp">
    <app-header></app-header>
    <div class="dynamic-container">
        <router-outlet></router-outlet>
    </div>
</div>